// src/store/user/userActions.js
// ✅ SECURITY: Auth gérée par cookie httpOnly
import { get } from '../../utils/apiClient'
import { setUser } from '../userSlice'
import { setUser as sentrySetUser } from '../../utils/sentry'

export const fetchUser = () => {
  return async (dispatch) => {
    try {
      // ✅ SECURITY: Vérifier via userId (le cookie sera envoyé automatiquement)
      const userId = localStorage.getItem('userId')
      if (!userId) {
        return
      }

      const data = await get('/members/profile')
      dispatch(setUser(data))
      // Enrichit la scope Sentry pour que toute erreur frontend soit attribuable
      // au user + tenant. No-op silencieux si Sentry désactivé.
      sentrySetUser(data)
    } catch (error) {
      console.error("Erreur lors de la récupération de l'utilisateur:", error)
    }
  }
}
